var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3c2f87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m198.47 376.21c0 3.95 1.21 7.8 3.47 11.04l14.21 20.39c1.45 2.08 3.83 3.33 6.37 3.33h51.89c2.54 0 4.92-1.24 6.37-3.33l14.21-20.39c2.26-3.24 3.47-7.09 3.47-11.04v-24.36h-99.98v24.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.93 90.94c-90.84-1.75-142.9 111.02-91.21 171.82 19.3 21.1 38.59 51.44 40.67 66.21l-.47 2.44h.66 100.68.66l-.47-2.44c2.08-14.78 21.37-45.11 40.67-66.21 51.72-60.8-.35-173.57-91.19-171.82zm-.14 59.32c-28.24 0-51.21 22.97-51.21 51.21 0 4.97-4.03 9-9 9s-9-4.03-9-9c0-38.16 31.05-69.21 69.21-69.21 4.97 0 9 4.03 9 9s-4.03 9-9 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.19 141c2.44 0 4.92-.6 7.22-1.86l16.35-8.99c7.26-3.99 9.91-13.11 5.91-20.37-3.99-7.26-13.11-9.91-20.37-5.91l-16.35 8.99c-7.26 3.99-9.91 13.11-5.91 20.37 2.72 4.96 7.85 7.77 13.15 7.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.65 196.95h-18.65c-8.28 0-15 6.72-15 15s6.72 15 15 15h18.66c8.28 0 15-6.72 15-15s-6.72-15-15.01-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.65 292.26-16.16-9.33c-7.17-4.14-16.35-1.68-20.49 5.49s-1.68 16.35 5.49 20.49l16.16 9.33c2.36 1.36 4.94 2.01 7.49 2.01 5.18 0 10.23-2.69 13-7.5 4.15-7.17 1.69-16.35-5.49-20.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.88 130.15 16.35 8.99c2.29 1.26 4.77 1.86 7.22 1.86 5.29 0 10.43-2.81 13.16-7.77 3.99-7.26 1.34-16.38-5.91-20.37l-16.35-8.99c-7.26-3.99-16.38-1.34-20.37 5.91-4 7.26-1.36 16.38 5.9 20.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.63 211.95c0-8.28-6.72-15-15-15h-18.65c-8.28 0-15 6.72-15 15s6.72 15 15 15h18.66c8.28 0 14.99-6.71 14.99-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.13 282.93-16.16 9.33c-7.17 4.14-9.63 13.32-5.49 20.49 2.78 4.81 7.82 7.5 13 7.5 2.54 0 5.12-.65 7.49-2.01l16.16-9.33c7.17-4.14 9.63-13.32 5.49-20.49s-13.31-9.63-20.49-5.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBulb);
export default __webpack_public_path__ + "static/media/icon-light-bulb.06599741cffbb948a9c5b09711b2b33e.svg";
export { ForwardRef as ReactComponent };